module.exports = __webpack_public_path__ + "img/heart.9c8f162c.svg";